import React, { memo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { FONTS } from '@bcm/constants';

const BodySiteCanvasLR = ({dims, isView}) => {

	const styles = StyleSheet.create({
		LRContainer: {
			position: 'absolute',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			padding: isView ? 0 : 20,
			width: dims.width,
			top: dims.height / 3
		},
		LRText: {
			fontFamily: FONTS.default,
			fontSize: dims.width / 8,
		},
	});

	return (
		<View style={styles.LRContainer}>
			<Text style={styles.LRText}>L</Text>
			<Text style={styles.LRText}>R</Text>
		</View>
	);};

export default memo(BodySiteCanvasLR);